import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DATE_TIME_FORMAT } from "../../../../constants";
dayjs.extend(utc);

interface PaymentRejectedFormProps {
    amount: number;
    reason: string;
    applicantRespondedAt: Date;
}

export const PaymentRejectedForm: React.FC<PaymentRejectedFormProps> = (props) => {
    return (
        <div
        style={{
          backgroundColor: "white",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "20px",
          paddingRight: "20px",
          margin: 10,
          textAlign: "left",
          border: "1px solid #d9d9d9",
          borderRadius: "8px",
        }}
      >
        <div>
            The request of US${props.amount} for {props.reason} was rejected by the applicant.
            <div
            className="shadow-sm"
            style={{
                margin: "10px 5px",
                padding: "10px",
                color: "black",
                borderRadius: "8px",
                background: "#FFF3CD",
                overflow: "auto",
            }}
            >
                <strong>US${props.amount} Payment Request Rejected</strong>
                <br/>
                {dayjs(props.applicantRespondedAt).utc().format(DATE_TIME_FORMAT).toString().toUpperCase()}
            </div>
        </div> 
    </div>
    )
}
